import _ from 'lodash'
import vm from '../main'
import { httpClient as http } from '../services'

const internals = {}

internals.updateHouse = houseInfo => {
  const promises = []
  return http
    .put('/update/house', {
        cdId: houseInfo.cdId,
      hnNo: houseInfo.hnNo,
      memberCount: houseInfo.familyMembers,
      houseStatus: houseInfo.houseStatus,
      contactPerson: houseInfo.contactPerson,
      contact: houseInfo.contact,
      cdaId:houseInfo.cdaId,
      houseTypeId:houseInfo.houseTypeId,
      houseTag:houseInfo.houseTag,
      geoLoc:houseInfo.geoLoc,
      _id: houseInfo._id,
    })
    .then(result => {
        houseInfo = result.data
      return result
    })
    .catch(error => {
      console.error('authService.inviteUser-error:\n', error)
      throw error
    })
}


internals.getById = id => {
  return http
    .get(`/house/byId?_id=${id}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('primaryTripService-error:\n', error)
      throw error
    })
}

internals.getHouseType = params => {
  return http
    .get(`/houseType/list?page=1&limit=999`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('houseTypeService-error:\n', error)
      throw error
    })
}

internals.getWasteCollectionAreaList = Id => {
  return http
    .get(`/waste-collection-area-list?cityId=${Id}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('primaryTripService-error:\n', error)
      throw error
    })
}


export default internals



// WEBPACK FOOTER //
// ./src/services/houses.service.js